import React from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logo from '../img/icons8-fruits-64.png';
import '../css/Style.css';
import {Link} from 'react-router-dom';

function Navbarmenu(){
    return(
        <>
        <Navbar collapseOnSelect expand="lg" className="bg slide-in-top">
      <Container>
        <Navbar.Brand href="#home"><img src={logo}/></Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav text-white" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
          </Nav>
          <Nav>
          <Nav.Link as ={Link} to="/" className="active">Home</Nav.Link>
            <Nav.Link as ={Link} to="/about">About</Nav.Link>
            <Nav.Link as ={Link} to="/ourfruit">OurFruits</Nav.Link>
            <Nav.Link as ={Link} to="/seasonal">Seasonal</Nav.Link>
            <Nav.Link as ={Link} to="/testimonial">Testimonials</Nav.Link>
            <Nav.Link as ={Link} to="/contact">Contact</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
        </>
    );
}

export default Navbarmenu;